
import { i18nText } from '@/locales';

    import { Component, Prop } from "vue-property-decorator";
    import FormGroup from "@/UI/components/common/form/FormGroup.vue";
    import PageTitle from "@/UI/components/common/PageTitle.vue";
    import VisitGeneralForm from "@/form/visits/visitGeneral";
    import {ITableColumn} from "@/entity/table/table.types";
    import { mixins } from "vue-class-component";
    import { SimpleProxyForm } from "@/UI/components/Helpers/SimpleProxyForm";
    import { ClientsMix } from "@/UI/mixins/ClientsMix";
    import BaseDataForm from "@/UI/components/Helpers/BaseForm/BaseDataForm.vue";
    import { VisitsGeneralMix } from "@/UI/mixins/Visits/VisitsGeneralMix";
    import { VisitsStore } from "@/store/modules/Visits";
    import { Button, FormModel, Input, List, Menu, Select, Table, Tabs, Row, Col } from "ant-design-vue";
    import { VisitPayFormData, formRules } from "@/form/visits/Pay/Visit";
    import { LoyaltySubscriptionStore } from "@/store/modules/Loyalty/Subscription/LoyaltySubscription";
    import { LoyaltyCertStore } from "@/store/modules/Loyalty/Cert/LoyaltyCert";
    import { ClientLoyaltyTableMix } from "@/UI/mixins/Loaylty/ClientLoyaltyTableMix";
    import { LoyaltyCertMix } from "@/UI/mixins/Loaylty/LoyaltyCertMix";
    import { SubscriptionMix } from "@/UI/mixins/Loaylty/SubscriptionMix";
    import { SubscriptionTableMix } from "@/UI/mixins/Loaylty/SubscriptionTableMix";
    import { CashBoxMix } from "@/UI/mixins/CashBoxMix";
    import { CashboxStore } from '@/store/modules/Finance/Cashbox';

    //http://localhost:8080/#/tests/index

    @Component({
        components: {
            FormGroup,
            PageTitle,
            BaseDataForm,
            "a-button": Button,
            "a-menu-item": Menu.Item,
            "a-list-item": List.Item,
            "a-list-item-meta": List.Item.Meta,
            "a-select": Select,
            "a-select-option": Select.Option,
            "a-table": Table,
            "a-input": Input,
            "a-tab": Tabs,
            "a-tab-pane": Tabs.TabPane,
            "a-form-model": FormModel,
            "a-form-model-item": FormModel.Item,
            "a-row": Row,
            "a-col": Col,
        },
    })
    export default class VisitPayment extends mixins(
        SimpleProxyForm,
        ClientsMix,
        VisitsGeneralMix,
        SimpleProxyForm,
        ClientLoyaltyTableMix,
        LoyaltyCertMix,
        SubscriptionMix,
        SubscriptionTableMix,
        CashBoxMix
    ) {
        @Prop() form!: VisitGeneralForm;
        @Prop() visit_id!: number;
        @Prop() client_id!: number | null;

        formVisit = new VisitPayFormData();
        Rules = formRules;
        showPayModal = false;
        confirmLoading = false;
        visibleCashCashboxes = false;
        visibleCardCashboxes = false;
        showSearchLoyaltyBlock = true;
        maskedPhone = '';
        boxData: any[] = []

        paymentMethods: any = null;

        get columns(): ITableColumn[] {
            return [
                {
                    title: i18nText("Позиция"),
                    dataIndex: '',
                    key: 'name',
                    width: '80%',
                    scopedSlots: {
                        customRender: 'name',
                    }
                },
                {
                    title: i18nText("Сумма, ₽"),
                    dataIndex: 'total',
                    key: 'total',
                    scopedSlots: {
                        customRender: 'total',
                    }
                }
            ]
        }

        pushToBox(data: Record<any, any>)
        {
            this.boxData.push(data);
        }

        handlePayCancel(): void {
            this.showPayModal = false;
        }
        async handlePayOk(): Promise<void> {
            this.showPayModal = false;
            this.formVisit.visit_id = this.form.id;
            try {
                let response = await VisitsStore.pay(this.formVisit);
                if(response && response.status)
                {
                    this.$message.success(response.response);
                } else {
                    this.$message.error(response.response);
                }
                await VisitsStore.fetchData({ filter: { id: this.visit_id } });
                this.paymentMethods = await VisitsStore.fetchPaymentMethods({ visit_id: this.visit_id } );
            } catch (e: any) {
                console.log(i18nText("Ошибка платежа"));
            } finally {
                //console.log('*** успешный платеж');
            }
        }
        handleCashboxPayment(id : number): void {
            this.formVisit.cashbox_id = id;
            this.formVisit.certificate_id = null;
            this.formVisit.membership_id = null;
            this.formVisit.account_pay = false;

            this.visibleCashCashboxes = false;
            this.visibleCardCashboxes = false;

            console.log('clicked handler');

            (this.$refs.PayForm as FormModel).validate((valid: any) => {
                if (valid) {
                    this.showPayModal = true;
                }
                else {
                    this.$message.error(i18nText("Не введена сумма для оплаты"));
                }
            });
        }
        handleCertificatePayment(record : Record<any, any>):void{
            this.formVisit.cashbox_id = null;
            this.formVisit.certificate_id = record.id;
            this.formVisit.membership_id = null;
            this.formVisit.account_pay = false;
            this.formVisit.sum = record.cost;
            this.showPayModal = true;
            
        }
        handleMembershipPayment(record : Record<any, any>):void{
            this.formVisit.cashbox_id = null;
            this.formVisit.membership_id = record.id;
            this.formVisit.certificate_id = null;
            this.formVisit.account_pay = false;
            this.formVisit.sum = record.cost;
            this.showPayModal = true;
        }
        handleAccountPayment(): void {
            this.formVisit.cashbox_id = null;
            this.formVisit.membership_id = null;
            this.formVisit.certificate_id = null;
            this.formVisit.account_pay = true;
            this.showPayModal = true;
            this.formVisit.sum = this.paymentMethods.client_account.will_debited;
        }
        handleMenuBankClick(): void {
            console.log("click");
        }

        handleButtonClick(): void {
            console.log("click left button");
        }

        collapsed(): void {

        }

        toggleSearchLoyaltyBlock(): void {
            this.showSearchLoyaltyBlock = this.showSearchLoyaltyBlock ? false : true;
        }

        get cash_cashboxes(): any {
            if(this.cashBoxes && this.cashBoxes.data)
            {
                return this.cashBoxes.data.filter(e => e && e.type && e.type.id == 1);
            } else {
                return [];
            }
        }

        get card_cashboxes(): any {
            if(this.cashBoxes && this.cashBoxes.data)
            {
                return this.cashBoxes.data.filter(e => e && e.type && e.type.id == 2);
            } else {
                return [];
            }
        }

        async onCertificatesSearch(val: any): Promise<void> {
            console.log(val);
        }

        async onSubscriptionSearch(val: any): Promise<void> {
            console.log(val);
        }

        async created(): Promise<void> {
            if(!this.visit_id)
            {
                this.visit_id = this.form.id;
            }
            if(!this.client_id)
            {
                this.client_id = this.form.client_id;
            }
            
            console.log("visit_id -" + this.visit_id);
            console.log("client_id -" + this.client_id);

            try {
                await CashboxStore.fetchAll({ filter: { salon_id: this.form.salon_id } });
                await VisitsStore.fetchData({ filter: { id: this.visit_id } });
                this.paymentMethods = await VisitsStore.fetchPaymentMethods({ visit_id: this.visit_id } );

                if(this.visit && this.visit.client)
                {
                    this.maskedPhone = this.visit.client.phone.replace(/(\d{1})(\d{3})(\d{3})(\d{2})(\d{2})/,"+$1 $2 $3-$4-$5")

                    if(this.visit.basket)
                    {
                        for(let i = 0; i < this.visit.basket.services.length; i++)
                        {
                            let service = this.visit.basket.services[i];
                            let totalPrice = service.price * service.quantity - (service.discount * service.price / 100);
                            this.pushToBox({
                                key:    service.service_id,
                                name:   service.service.name,
                                total:  totalPrice
                            })
                        }
                        for(let i = 0; i < this.visit.basket.products.length; i++)
                        {
                            let product = this.visit.basket.products[i];
                            let totalPrice = product.price * product.quantity - (product.discount * product.price / 100);
                            this.pushToBox({
                                key:    product.product_id,
                                name:   product.product.nomenclature.name,
                                total:  totalPrice
                            })
                        }
                        for(let i = 0; i < this.visit.basket.certificates.length; i++)
                        {
                            let certificate = this.visit.basket.certificates[i];
                            let totalPrice = certificate.price * certificate.quantity - (certificate.discount * certificate.price / 100);
                            this.pushToBox({
                                key:    certificate.certificate_id,
                                name:   i18nText("Сертификат №") + certificate.certificate.code,
                                total:  totalPrice
                            })
                        }
                        for(let i = 0; i < this.visit.basket.memberships.length; i++)
                        {
                            let membership = this.visit.basket.memberships[i];
                            let totalPrice = membership.price * membership.quantity - (membership.discount * membership.price / 100);
                            this.pushToBox({
                                key:    membership.membership_id,
                                name:   i18nText("Абонемент №") + membership.membership.membership_number,
                                total:  totalPrice
                            })
                        }
                    }
                }

                this.tableLoad = true;
                this.formReady = true;
            } catch (e) {
                console.log("error parse Visit Data");
            }
        }
    }
